module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "chart-header"
  }, [_c('div', {
    staticClass: "chart-title"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.chartIcon
  }), _vm._v("\n      " + _vm._s(_vm.chartTitle) + "\n      "), _c('span', {
    staticClass: "badge badge-primary ml-2"
  }, [_vm._v(_vm._s(_vm.displayedClients) + " Clients")]), _vm._v(" "), (_vm.chartType === 'bar') ? _c('span', {
    staticClass: "badge badge-info ml-1"
  }, [_vm._v(_vm._s(_vm.dynamicChartHeight) + "px")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "chart-controls"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Show Top:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLimit),
      expression: "selectedLimit"
    }],
    staticClass: "form-control form-control-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedLimit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateChart]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('apexchart', {
    attrs: {
      "type": _vm.chartType,
      "height": _vm.dynamicChartHeight,
      "options": _vm.apexOptions,
      "series": _vm.apexSeries
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ccb1974","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/ClientTeusFlexibleChart.vue
// module id = 2772
// module chunks = 0